export const ERROR = 'errors/ERROR';
export const SHOW_MODAL = 'errors/SHOW_MODAL';
